export enum TRACKING_ACTION {
  ACCESS_CHECKOUT = 'access_checkout',
  ADD_REWARD = 'add_reward',
  CLICK_OFFBOARDING = 'click_offboarding',
  CLICK_SHARE = 'click_share',
  DISPLAY_REWARD = 'display_reward',
  FOLLOW_PROJECT = 'follow_project',
  OPEN_SHARE = 'open_share',
}

export enum TRACKING_SOURCE {
  BACKER_BLOCK = 'source_backer_block',
  BACKERS = 'source_backers',
  FIRST_TIME_FOOTER = 'source_1st_time_footer',
  HERO = 'source_hero',
  MODAL = 'source_modal',
  NEWS = 'source_news',
  PAYMENT_DISTURBANCE = 'source_payment_disturbance_modal',
  PROJECT = 'source_project',
  PROJECT_BACKERS_LISTING = 'project_backers_listing',
  REWARD_MODAL = 'source_reward_modal',
  REWARDS = 'source_rewards',
  STICKY_MENU = 'source_sticky_menu',
  STICKY_MOBILE = 'source_sticky_mobile',
}
